import React from 'react';
import { ArrowIcon } from '@encarpkg/design';
import classNames from 'classnames/bind';
import styles from './MyArrowButton.module.scss';

const cx = classNames.bind(styles);

function MyArrowButton({ children, onClick, className = '', style = null, arrowSize = 12, arrowColor = '#666' }) {
	return (
		<button
			className={cx('btn', className)}
			type="button"
			onClick={onClick}
			style={style}
		>
			{children}
			<ArrowIcon
				width={arrowSize}
				height={arrowSize}
				fillColor={arrowColor}
			/>
		</button>
	);
}

export default MyArrowButton;
